import classnames from 'classnames';
import * as React from 'react';
import './FilterDropdown.scss';

type FilterDropdownProps = React.PropsWithChildren<{
    className?: string;
}>;

export default function FilterDropdown({
    className,
    children,
} : FilterDropdownProps) {
    return (
        <div className={classnames('palette-filter-dropdown', className)}>
            {children}
        </div>
    );
}
